var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUploadPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiBox-root",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 13H10V16H11V13Z",
    fill: "#F63B3B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 2H6C4.9 2 4 2.9 4 4V11C3.448 11 3 11.448 3 12V17C3 17.552 3.448 18 4 18V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM5 17V12H7C7.55 12 8 12.45 8 13V14C8 14.55 7.55 15 7 15H6V17H5ZM18 20H6V18H15C15.552 18 16 17.552 16 17V12C16 11.448 15.552 11 15 11H6V4H13V9H18V20ZM9 17V12H11C11.55 12 12 12.45 12 13V16C12 16.55 11.55 17 11 17H9ZM15 14V15H14V17H13V12H15V13H14V14H15Z",
    fill: "#F63B3B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 13H6V14H7V13Z",
    fill: "#F63B3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUploadPdf);
export default __webpack_public_path__ + "static/media/icon-upload-pdf.adbca3cc67882fc26a8063de380fc7e7.svg";
export { ForwardRef as ReactComponent };